import { useQuery } from '@tanstack/react-query';
import { Card, CardContent, CardHeader, CardTitle } from '@mlm/ui';
import { getLedger, getWallet } from '../lib/api';

export function WalletPage() {
  const { data: wallet } = useQuery({ queryKey: ['merchant-wallet'], queryFn: getWallet });
  const { data: ledger = [] } = useQuery({ queryKey: ['merchant-ledger'], queryFn: getLedger });

  return (
    <div className="max-w-3xl space-y-4">
      <h1 className="text-2xl font-semibold">Wallet</h1>
      <div className="grid grid-cols-2 gap-4">
        <Card>
          <CardHeader>
            <CardTitle className="text-sm text-muted-foreground">Available</CardTitle>
          </CardHeader>
          <CardContent className="text-2xl font-semibold tabular-nums">
            ₱{Number(wallet?.available ?? 0).toFixed(2)}
          </CardContent>
        </Card>
        <Card>
          <CardHeader>
            <CardTitle className="text-sm text-muted-foreground">Lifetime earned</CardTitle>
          </CardHeader>
          <CardContent className="text-2xl font-semibold tabular-nums">
            ₱{Number(wallet?.lifetimeEarned ?? 0).toFixed(2)}
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Ledger</CardTitle>
        </CardHeader>
        <CardContent className="p-0">
          {ledger.length === 0 ? (
            <p className="py-8 text-center text-muted-foreground text-sm">No entries yet.</p>
          ) : (
            <table className="w-full text-sm">
              <thead className="border-b text-left text-muted-foreground">
                <tr>
                  <th className="p-3">Kind</th>
                  <th className="p-3">Order</th>
                  <th className="p-3">Amount</th>
                  <th className="p-3">Date</th>
                </tr>
              </thead>
              <tbody>
                {ledger.map((r) => {
                  const b = r.metadata?.breakdown;
                  return (
                    <tr key={r.id} className="border-b last:border-0 hover:bg-muted/30 align-top">
                      <td className="p-3 capitalize">{r.kind.replace(/_/g, ' ')}</td>
                      <td className="p-3 font-mono text-xs">{r.orderCode ?? '—'}</td>
                      <td
                        className={`p-3 tabular-nums ${r.direction === 'C' ? 'text-credit' : 'text-debit'}`}
                      >
                        <div>
                          {r.direction === 'C' ? '+' : '−'}₱{Number(r.amount).toFixed(2)}
                        </div>
                        {b && (
                          <div className="mt-0.5 text-[11px] font-normal text-muted-foreground">
                            ₱{Number(b.gross).toFixed(2)} gross − ₱{Number(b.vat).toFixed(2)} VAT
                            <span className="block">
                              (after ₱{Number(b.fee).toFixed(2)} platform fee)
                            </span>
                          </div>
                        )}
                      </td>
                      <td className="p-3 text-muted-foreground">
                        {new Date(r.createdAt).toLocaleString()}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
